import { isEmpty } from './Validation';

/**
 * remove all key, value pairs from the object that match the comparator (fn)
 * @param {*} obj 
 * @param {*} comparator 
 */
export const omitBy = (obj, comparator) => {
    return Object.keys(obj)
        .filter(key => !comparator(obj[key], key))
        .reduce((acc, key) => ((acc[key] = obj[key]), acc), {});
};

export const removeEmptyEntries = (obj) => {
    return omitBy(obj, x => isEmpty(x));
};

/**
 * get the name field from the array of objects using the id
 * @param {String} id 
 * @param {Array} list objects that have an id and name field
 */
export const getObjectNameById = (id, list) => {
    if (Array.isArray(list) && id) {
        const entry = list.find(obj => obj?.id === id);
        return entry?.name ? entry?.name : '';
    }
    return '';
};




// WEBPACK FOOTER //
// ./services/objectService.js